import React, {Component} from "react";
import {} from "@mui/material";
import {
	Table,
	Filter,
	DialogInformation
} from "./components";
import agent from "../../../agent/agent";

const initFilter = {
	vin: "",
	client: "",
	mechanic: "",
	tricepsOrderId: "",
	page: 1,
};

class VehicleInspection extends Component {
	constructor(props) {
		super(props);

		this.state = {
			items: [],
			filter: {...initFilter},
			totalPages: 1,
			isLoading: true,
		};
		this.refDialogInformation = React.createRef();
	}

	componentDidMount = async () => {
		await this.getItems();
	}

	getItems = async () => {
		await this.setState({ isLoading: true });

		const filter = this.getFilter();
		const response = await agent.get(`/orders/vehicle-inspection?${ filter }`)
			.then((res) => res?.data || null)
			.catch(() => null);

		await this.setState({
			isLoading: false,
			items: response?.data || [],
			totalPages: response?.last_page,
		});
	}

	getFilter = () => {
		let str = [
			'limit=20'
		];

		const filter = {...this.state.filter};
		Object.keys(filter).map((filterKey) => {
			const filterValue = filter[filterKey];
			if (!!filterValue) {
				str.push(`${ filterKey }=${ filterValue }`);
			}
		});

		return str.join('&')
	}
	resetFilter = async () => {
		await this.setState({filter: {...initFilter}});
		await this.getItems();
	}
	changeFilter = async (filter, isSend) => {
		await this.setState({ filter });
		if (!isSend) {
			return
		}
		await this.getItems();
	}

	render() {
		const {
			items,
			filter,
			totalPages,
			isLoading,
		} = this.state;

		return (
			<>
				<Filter
					filter={filter}
					onSubmit={this.getItems}
					onReset={this.resetFilter}
					onChange={this.changeFilter}
				/>
				<Table
					items={items}
					filter={filter}
					isLoading={isLoading}
					totalPages={totalPages}
					onChangePage={this.changeFilter}
				/>
				<DialogInformation ref={this.refDialogInformation}/>
			</>
		);
	}
}

export default VehicleInspection
